module.exports = __webpack_public_path__ + "img/zahn-behandlungsplan-einreichen.dfe1888f.svg";